import { render } from "./Game.vue?vue&type=template&id=5460cf12"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=5460cf12&scss=true&lang=css"

import exportComponent from "E:\\project2\\skin-web\\最强武装\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__